@if (error$ | async) {
<ish-error-message [error]="error$ | async" [toast]="false" />
<h1 data-testing-id="empty-confirmation-title">
  {{ 'personal.data.request.confirmation.empty.heading' | translate }}
</h1>
<div [ishServerHtml]="'personal.data.request.confirmation.empty.message' | translate"></div>
} @if ((loading$ | async) === false && !!(error$ | async) === false) { @if (firstGDPRDataRequest$ | async) {
<h1 data-testing-id="successful-confirmation-title">
  {{ 'personal.data.request.confirmation.success.heading' | translate }}
</h1>
<div [ishServerHtml]="'personal.data.request.confirmation.success.message' | translate"></div>
} @else {
<h1 data-testing-id="already-confirmed-title">
  {{ 'personal.data.request.confirmation.confirmed.heading' | translate }}
</h1>
<div [ishServerHtml]="'personal.data.request.confirmation.confirmed.message' | translate"></div>
} } @if (loading$ | async) {
<ish-loading />
}
